export enum AssetState {
  Provisioned = 'PROVISIONED',
  BurnIn = 'BURN_IN',
  BurnInFail = 'BURN_IN_FAIL',
  Calibration = 'CALIBRATION',
  Complete = 'COMPLETE',
  Hidden = 'HIDDEN',
}
